/**
 * -----------------------------------------------------------------------------
 * Project  : ReelConsensus app - Frontend Entrypoint
 * File     : index.js
 * Author   : Zachary Dry
 * Created  : 2025-09-18
 * Updated  : 2025-09-19
 * Version  : 1.0
 * License: Proprietary (Company Confidential)
 * -----------------------------------------------------------------------------
 * Description:
 *   Bootstraps the React application, mounts the root component, and providers.
 *   
 *
 * Dependencies:
 *   - ./App
 *   - ./context/AuthContext
 *   - react
 *   - react-dom/client
 *   - react-router-dom
 *
 * Usage:
 *   Start app with: npm run start (served by dev server).
 * -----------------------------------------------------------------------------
 */
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './context/AuthContext';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// Register a simple service worker for PWA (optional; uses CRA's public service worker path if present)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {});
  });
}


